export default "__VITE_ASSET__4IneHYlY__"